<template>
  <div class="pc-box">
    <section>
      <!-- 收起目录 -->
      <img
        :src="catalogState ? catalogClose : catalogOpen"
        class="catalog-btn"
        @click="catalogState = !catalogState"
        v-if="$i18n.locale === 'zh'"
      />
      <img
        :src="catalogState ? catalogCloseEn : catalogOpenEn"
        class="catalog-btn"
        @click="catalogState = !catalogState"
        v-else
      />
      <!-- 左侧列表 -->
      <div :class="catalogState ? 'left' : 'hide-left'">
        <course-title2 :courseTitle="courseTitle" :showCourse="showCourse"></course-title2>
        <select-tree></select-tree>
      </div>
      <!-- 右侧内容区域 -->
      <div class="right">
        <span
          class="prev"
          @click="chapterTurn(-1)"
          v-if="!(pIndex == 0 && cIndex == 0) && !Zhead && showPrev"
        ></span>
        <span
          class="prev"
          @click="changeHeadTail('Head')"
          v-else-if="pIndex == 0 && cIndex == 0 && !Zhead && showPrev"
        ></span>
        <span
          class="next"
          @click="chapterTurn(1)"
          v-if="!(pIndex == partLength && cIndex == curChapterLength) && !Ztail && showPrev"
        ></span>
        <span
          class="next"
          @click="changeHeadTail('Tail')"
          v-else-if="
            pIndex == partLength && cIndex == curChapterLength && !Ztail && showPrev
          "
        ></span>
        <router-view />
      </div>
    </section>
    <!-- 简介+关闭  无需关注 -->
    <div
      class="img-previous"
      v-if="$store.state.showPubAlertBg"
      @click="closeModul"
    >
      <div class="img" v-if="$store.state.imgPrevious">
        <div class="close-btn" @click="closeImg"></div>
        <!-- 放大按钮 -->
        <!-- <div class='zoom-btn' @click='zoomImg'></div> -->
        <img :src="$store.state.imgPreviousUrl" alt />
      </div>
      <div class="drag-direc" v-if="$store.state.dragDirec">
        <img
          src="../../assets/img/drag-direc.png"
          alt
          @click="recordDragFirstTime"
        />
      </div>
      <div :class="$global_config.title === 1 ? 'course-direc' : 'top-course-direc'" v-if="$store.state.courseAlertStatus">
        <div class="box scroll_config">
          <div class="direc-box">{{ courseDirec }}</div>
        </div>
      </div>
      <div :class="$global_config.title === 1 ? 'course-direc' : 'top-course-direc'" class="course-info" v-if="$store.state.courseInfoAlertStatus">
        <div class="box scroll_config">
          <div :class="['direc-box', {'active': isActive == index || courseIndex == index}]"
            v-for="(item, index) in data.materials" :key="index" @click="previewPdf(item, index)" :title="item.title">{{item.title}}</div>
        </div>
      </div>
      <message-box :isShow="$store.state.pubMessbox"></message-box>
    </div>
  </div>
</template>
<script>
import SelectTree from './TreeSelect' // 树形选择框
import CourseTitle2 from 'components/PC/CourseTitle2' // 题目
import MessageBox from 'components/PC/MessageBox' // 公共弹框
import psCommonMethods from './mixins/index.js'
export default {
  name: 'Main',
  mixins: [psCommonMethods],
  data () {
    return {
      imgSrc: this.$store.state.imgPreviousUrl,
      courseTitle: data.res_title,
      courseDirec: data.res_desc,
      pIndex: this.$store.state.currentPartIndex,
      cIndex: this.$store.state.currentChapterIndex,
      partLength: 0, // 所有章节长度
      curChapterLength: 0, // 当前小节长度
      // 目录显示状态
      catalogState: true,
      catalogOpen: require('@/assets/img/picTest/open.png'),
      catalogClose: require('@/assets/img/picTest/close.png'),
      showCourse: true,
      catalogOpenEn: require('@/assets/img/picTest/open-en.png'),
      catalogCloseEn: require('@/assets/img/picTest/close-en.png'),
      isActive: null,
      courseIndex: this.$store.state.isActiveIndex
    }
  },
  computed: {
    partIndex () {
      return this.$store.state.currentPartIndex
    },
    chapterIndex () {
      return this.$store.state.currentChapterIndex
    },
    Zhead () {
      return this.$store.state.Zhead
    },
    Ztail () {
      return this.$store.state.Ztail
    },
    showPrev () {
      return this.$store.state.showPrev
    },
    isActiveIndex () {
      // console.log(50000, this.$store.state.activeIndex)
      return this.$store.state.isActiveIndex
    }
  },
  watch: {
    partIndex (nv) {
      this.pIndex = nv
      this.curChapterLength =
        this.data.part_list[this.pIndex].chapter_list.length - 1 // 更新当前章节小节数
    },
    chapterIndex (nv) {
      this.cIndex = nv
    },
    isActiveIndex (index) {
      // console.log(3333, index)
      this.courseIndex = index
    }
  },
  created () {
    if (!location.href.includes('pcindex/preview')) {
      this.intoDetailPage(this.data)
      // console.log(50233333333333)
      // alert(333)
      // this.$store.commit('showPrev', true)
    }
    this.partLength = this.data.part_list.length - 1
    this.curChapterLength =
      this.data.part_list[this.pIndex].chapter_list.length - 1
  },
  components: {
    SelectTree,
    CourseTitle2,
    MessageBox
  },
  methods: {
    previewPdf (item, index) {
      this.isActive = index
      // console.log(2222, index)
      this.$store.commit('isActiveIndex', index)
      this.$router.replace({ path: '/pcindex/preview', query: { path: item.path } })
    },
    closeImg () {
      this.$store.commit('showPubAlertBg', false)
      this.$store.commit('showPreviousPic', false)
    },
    // 放大图片
    zoomImg () { },
    recordDragFirstTime () {
      this.$store.commit('showPubAlertBg', false)
      this.$store.commit('dragDirection', false)
      localStorage.setItem('firstTime', true)
    },
    handleToggleClick () {
      this.type = this.type === 'name' ? 'mail' : 'name'
    },
    // 关闭弹窗
    closeModul () {
      if (this.$store.state.courseAlertStatus) {
        this.$store.commit('courseAlertStatus', false) // 弹窗白色显示隐藏
      }
      if (this.$store.state.courseInfoAlertStatus) {
        this.$store.commit('courseInfoAlertStatus', false) // 弹窗白色显示隐藏
      }
      this.$store.commit('showPubAlertBg', false) // 弹窗灰色背景显示隐藏
    }
  }
}
</script>

<style lang="less" scoped>
.pc-box {
  // min-width: 1102px;
  min-width: 1000px;
  height: 100%;
  overflow: hidden;
  font-size: 16px;
  font-family: "微软雅黑";
  header {
    padding: 0 3%;
    background: #f8f8f8;
  }
  section {
    display: flex;
    // padding: 3% 0 3% 3%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px 0 10px 20px;
    position: relative;
  }
  .left {
    min-width: 160px;
    width: 23%;
    height: 100%;
    overflow-y: auto;
  }
  .hide-left {
    .left;
    width: 0;
    min-width: 0;
    overflow-x: hidden;
  }
  .catalog-btn {
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    cursor: pointer;
    transition: all 0.25s;
    z-index: 9;
  }
  .right {
    background: #fff;
    flex: 1;
    // padding: 0 50px;
    position: relative;
    // min-width:834px;
    min-width: 800px;
    box-sizing: border-box;
    height: 100%;
    .prev,
    .next {
      display: block;
      cursor: pointer;
      width: 28px;
      height: 50px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;
      background: url("../../assets/img/prev.png") no-repeat no-repeat
        center/contain;
    }
    .prev {
      left: 60px;
    }
    .next {
      right: 60px;
      transform: rotate(180deg) translateY(50%);
    }
  }
  .img-previous {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    .img {
      width: 800px;
      height: 400px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
      .close-btn {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 50px;
        height: 50px;
        background: rgba(0, 0, 0, 0.3) url("../../assets/img/close.png")
          no-repeat no-repeat center/20px 20px;
        border-radius: 100%;
      }
      .zoom-btn {
        position: absolute;
        right: 100px;
        top: 20px;
        width: 50px;
        height: 50px;
        background: rgba(0, 0, 0, 0.3) url("../../assets/img/zoom2.png")
          no-repeat no-repeat center/24px 24px;
        border-radius: 100%;
      }
    }
    .drag-direc {
      width: 800px;
      height: 400px;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
    .top-course-direc {
      .course-direc;
      top: 10px;
    }
    .course-direc {
      width: 640px;
      background: #fff;
      color: #656565;
      padding: 20px 30px;
      box-sizing: border-box;
      border-radius: 4px;
      position: absolute;
      top: 46px;
      // left: 10%;
      left: 125px;
      .box {
        min-height: 100px;
        max-height: 286px;
        overflow-y: auto;
        padding: 10px;
      }
      .direc-box {
        overflow-y: auto;
        text-align: justify;
        line-height: 36px;
        word-break: break-word;
      }
      &.course-info{
        width: 199px;
        left: 215px;
        padding: 0;
        max-height: 342px;
        .direc-box {
          cursor: pointer;
          font-size: 14px;
          line-height: 32px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          &.active{
            color: #005587;
          }
        }
        .box{
          min-height: auto;
          padding: 10px 20px;
          max-height: 322px !important;
        }
      }
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        border-top: 10px solid transparent;
        border-right: 10px solid #ffffff;
        position: absolute;
        left: -18px;
        top: 18px;
        z-index: 20;
      }
      /* 滚动条 */
      .scroll_config::-webkit-scrollbar {
        width: 8px;
      }

      .scroll_config::-webkit-scrollbar-thumb {
        background-color: #bebdbe;
        border: solid 1px #bebdbe;
        border-radius: 4px;
      }

      .scroll_config::-webkit-scrollbar-track {
        /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255);
        border-radius: 2px;
        background: #ededed;
      }
    }
  }
}
</style>
